<template>
  <div id="app" v-cloak>
    <div class="test-page-header box">
      <div>
        <div class="h1">{{testData.testPaperName}}
        
        </div>
        <template v-if="testData.isScore == 0">
          <div class="h1-title">共{{testData.maxSort}}题，{{testData.totalScore}}分 </div>
        </template>
        <template v-else>
          <div class="h1-title">共{{testData.maxSort}}题</div>
        </template>
      
      </div>
      
      <div class="h1-right">
        <!-- <span class="total-point">90分</span> -->
      </div>
    </div>
    <div class="test-page-content">
      <div class="test-page-content-panel box " id="left">
        
        <div class="test-content-heder " v-for="(item,index) in testData.questionResModelList">
          <template v-if="testData.isScore == 0">
            <div class="big-test-title ">{{testIndexCN[index]}}、{{item.questionTypeName}}（共{{item.questionNumPerType}}小题，{{testData.questionResModelList[index].score}}分）</div>
          </template>
          <template v-else>
            <div class="big-test-title ">{{testIndexCN[index]}}、{{item.questionTypeName}}（共{{item.questionNumPerType}}小题）</div>
          </template>
          
          <div v-for="(item2,index2) in item.questionLst" class="test-item-box">
            <!-- {{item.testindex}} -->
            <TestItemSingle v-if="1==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                            :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemSingle>
            <TestItemMultiple v-if="2==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                              :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemMultiple>
            <TestItemJudge v-if="3==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                           :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemJudge>
            <TestItemWordselect v-if="9==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                                :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemWordselect>
            <TestItemPair v-if="8==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                          :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemPair>
            <TestItemFillbank v-if="4==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                              :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemFillbank>
            <TestItemQuestion v-if="5==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                              :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemQuestion>
            <TestItemCalculation v-if="6==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                                 :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemCalculation>
            <TestItemComplex v-if="7==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                             :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemComplex>
            <TestItemReading v-if="10==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                             :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemReading>
            <TestItemPickWrong v-if="13==item2.questionType" :data="item2" :test-index="item2.sort" :test-point="item2.score"
                               :show-timer="false" :show-answer="true" :show-resolve="true"></TestItemPickWrong>
            <div class="test-jiexi">
              <!-- <div><i class="el-icon-check"></i><span>答对了</span></div> -->
              <!-- <div>答案：{{item2.questionAnswer}}</div> -->
            </div>
          </div>
        
        </div>
      </div>
      <div class="test-page-bar box">
      
      </div>
    </div>
  </div>
</template>

<script>
  import https from '@/https.js';
  import TestItemSingle from './Task/TestItemSingle.vue';
  import TestItemMultiple from './Task/TestItemMultiple.vue';
  import TestItemJudge from './Task/TestItemJudge.vue';
  import TestItemWordselect from './Task/TestItemWordselect.vue';
  import TestItemPair from './Task/TestItemPair.vue';
  import TestItemFillbank from './Task/TestItemFillbank.vue';
  import TestItemQuestion from './Task/TestItemQuestion.vue';
  import TestItemCalculation from './Task/TestItemCalculation.vue';
  import TestItemPickWrong from './Task/TestItemPickWrong.vue';
  import TestItemComplex from './Task/TestItemComplex.vue';
  import TestItemReading from './Task/TestItemReading.vue';
  export default {
    name: 'TestAndTaskDetail',
    props: ['testPaperId'],
    components: {
      TestItemSingle: TestItemSingle,
      TestItemMultiple: TestItemMultiple,
      TestItemJudge: TestItemJudge,
      TestItemWordselect: TestItemWordselect,
      TestItemPair: TestItemPair,
      TestItemFillbank: TestItemFillbank,
      TestItemQuestion: TestItemQuestion,
      TestItemCalculation: TestItemCalculation,
      TestItemComplex: TestItemComplex,
      TestItemReading: TestItemReading,
      TestItemPickWrong: TestItemPickWrong
      
    },
    data() {
      return {
        testIndexCN: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十','十一'],
        testData: {
          testPaperName: "",
          dateTimeStr: null,
          questionResModelList: [],
          totalNum: 0,
        },
        dreamtime: 0,
      };
    },
    methods: {
      search(testPaperId) {
        console.log("作业与测试预览--单独栏目");
        let params = {
          testPaperId: testPaperId,
          isChecked: true
        }
        // /testPaperQuestion/preview  testPaperId
        https.fetchPost('/testPaperQuestion/preview',params ,"json").then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            let d = data.data.data;
            this.testData = d;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败'+msg
            });
          }
        }).catch(err=>{
              console.log(err)
            }
        )
      },
      
    },

    created: function() {
      this.search(this.testPaperId);
      console.log(this.testPaperId);
    }
  };
</script>

<style scoped>
  .test-item-daan {
    margin-top: 10px;
    border-top:none ;
  }
  
  
  .content-bg{
    background-color: lightgrey;
  }
  .box{
    background-color: white;
    
  }
  header{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    margin: 20px;
    height: 50px;
  }
  .h1{
    font-size: 38px;
    padding: 30px;
  }
  .h1-title{
    padding: 30px;
  }
  .h1-right{
    padding: 30px;
    font-size: 38px;
  }
  .test-page-header{
    margin: 20px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    
  }
  .test-page-content{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    margin: 20px;
    
  }
  .test-page-content-panel{
    flex-grow: 1;
    padding: 20px;
  }
  .test-page-bar{
    width:360px;
    min-width:360px;
    margin-left: 20px;
    min-height: 600px;
  }
  .test-toolbar-panel{
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    flex-direction: column;
    background-color:white;
    padding: 20px;
    width:320px;
    border-bottom: 1px solid lightgrey;
  }
  .test-toolbar-panel-content{
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    padding: 10px;
    
  }
  .test-mini-item{
    display: flex;
    display: -webkit-flex;
    width: 30px;
    height:30px;
    color: white;
    font-weight: bolder;
    border-radius: 50%;
    margin-right: 10px;
    background: #AEADAD;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;
  }
  /* .test-toolbar-panel:first-child{
    padding: 10px;
    border-bottom: 1px solid lightgrey;
  } */
  .total-point{
    padding: 30px;
    font-size: 38px;
    color:red;
    
  }
  .test-toolbar-bar{
    display: flex;
    display: -webkit-flex;
    align-items: baseline;
  }
  .test-mini-panel-title{
    display: flex;
    display: -webkit-flex;
    justify-content:space-between;
    padding: 10px;
    width:300px;
  }
  .test-mini-panel{
    display: flex;
    display: -webkit-flex;
    justify-content:flex-start;
    flex-wrap:wrap;
    
    padding: 10px;
  }
  .test-toolbar-time-title{
    color:grey;
  }
  .test-toolbar-time{
    padding: 10px;
    font-size: 30px;
    color:lightslategray;
  }
  .contact{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    color:lightslategray ;
  }
  .phone-box{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #58B3E6;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    margin:10px ;
  }
  .test-content-heder{
    border-bottom: 1px dotted lightgray;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .big-test-title{
    font-size: 18px;
    color: dimgrey;
    margin-bottom: 10px;;
  }
  .test-jiexi div{
    padding: 5px;
  }
  .floatfixed{
    position:absolute;
    z-index:40;
  }
  .floatfixed2{
    position:absolute;
    z-index:20;
    overflow:auto;
  }
  .rightscoll{
    overflow:auto;
  }
</style>
